<template>
  <LoaderWrapper ref="pageLoader" class="h-100">
    <ConfirmModal ref="confirmModal" />
    <div  class="row  m-4 mt-0">
      <div class="col-sm-12">
        <div class="row">

          <div class="col-sm-12">
            <div class="card card-body">
              <div class="row mt-2">

                <div class="form-group mb-2 col-md-3 col-lg-3 col-xl-2 me-2">
                  <div class="col p-0">
                    <div class="">
                      <input type="text" class="form-control form-control-sm" placeholder="ID" v-model="requestDTO.id">
                    </div>
                  </div>
                </div>

                <div class="form-group mb-2 col-md-3 col-lg-3 col-xl-2 me-2">
                  <div class="col p-0">
                    <div class="">
                      <input type="text" class="form-control form-control-sm" @keydown.enter="() => applyFilters()" :placeholder="trans('labels.customer_id')" v-model="requestDTO.userId">
                    </div>
                  </div>
                </div>

                <div class="form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2">
                  <div class="col p-0">
                    <div class="">
                      <DatePicker v-model="requestDTO.fromDate" mode="dateTime" :model-modifiers="{string: true}"  is24hr :masks="{modelValue: 'YYYY-MM-DD HH:mm:ss', inputDateTime24hr: 'YYYY-MM-DD HH:mm:ss'}">
                        <template v-slot="{ inputValue, togglePopover, inputEvents }">
                          <input
                            class="form-control form-control-sm"
                            :placeholder="trans('labels.from_date')"
                            :value="inputValue"
                            @focus="togglePopover"
                            @change="inputEvents.change"
                          />
                        </template>
                      </DatePicker>
                    </div>
                  </div>
                </div>

                <div class="form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2">
                  <div class="col p-0">
                    <div class="">
                      <DatePicker v-model="requestDTO.toDate" mode="dateTime" :model-modifiers="{string: true}"  is24hr :masks="{modelValue: 'YYYY-MM-DD HH:mm:ss', inputDateTime24hr: 'YYYY-MM-DD HH:mm:ss'}">
                        <template v-slot="{ inputValue, togglePopover, inputEvents }">
                          <input
                            class="form-control form-control-sm"
                            :placeholder="trans('labels.to_date')"
                            :value="inputValue"
                            @focus="togglePopover"
                            @change="inputEvents.change"
                          />
                        </template>
                      </DatePicker>
                    </div>
                  </div>
                </div>

                <div v-if="store.getters.isMerchant || store.getters.isAdmin" class="form-group pb-2 pe-2 col-md-3 col-lg-3 col-xl-2">
                  <div class="col p-0">
                    <div class="">
                      <input type="text"
                             class="form-control form-control-sm"
                             @keydown.enter="() => applyFilters()"
                             :placeholder="helper.trans('labels.from_sum')"
                             v-model="requestDTO.fromSum">
                    </div>
                  </div>
                </div>

                <div v-if="store.getters.isMerchant || store.getters.isAdmin" class="form-group pb-2 pe-2 col-md-3 col-lg-3 col-xl-2">
                  <div class="col p-0">
                    <div class="">
                      <input type="text"
                             class="form-control form-control-sm"
                             @keydown.enter="() => applyFilters()"
                             :placeholder="helper.trans('labels.to_sum')"
                             v-model="requestDTO.toSum">
                    </div>
                  </div>
                </div>

                <div v-if="!store.getters.isMerchant" class="form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2">
                  <div class="col p-0">
                    <div class="">
                      <Multiselect id="currencies"
                                   class="multiselect-sm"
                                   v-model="requestDTO.currencies"
                                   :options="currencyList"
                                   :custom-label="(opt) => `${opt}`"
                                   :multiple="true"
                                   select-label="Select"
                                   :placeholder="trans('labels.currencies')"
                      >
                      </Multiselect>
                    </div>
                  </div>
                </div>

                <div class="form-group mb-2 col-md-3 col-lg-3 col-xl-2 me-2">
                  <div class="col p-0">
                    <div class="">
                      <Multiselect id="statuses"
                                   class="multiselect-sm"
                                   v-model="requestDTO.statuses"
                                   :options="Object.values(InvoiceStatus)"
                                   :custom-label="(opt) => trans(`invoice_status.${opt}`)"
                                   :multiple="true"
                                   select-label="Select"
                                   :placeholder="trans('labels.statuses')"
                      >
                      </Multiselect>
                    </div>
                  </div>
                </div>

                <div v-if="currentStore === null" class="form-group mb-2 col-md-3 col-lg-3 col-xl-2 me-2">
                  <div class="col p-0">
                    <div class="">
                      <Multiselect id="store"
                                   class="multiselect-sm"
                                   v-model="requestDTO.storeIds"
                                   :options="storeIds"
                                   :custom-label="(opt) => store.getters['merchantStores/get'](opt)?.name"
                                   :multiple="true"
                                   select-label="Select"
                                   :placeholder="trans('labels.stores')"
                      >
                      </Multiselect>
                    </div>
                  </div>
                </div>

                <div class="form-group mb-2 col">
                  <div class="col-auto p-0 text-end ">
                    <button type="button" @click.prevent="exportInvoices" class="btn btn-outline-success btn-sm rounded-pill me-2 text-capitalize-first">
                      <i class="fa fa-download me-1"></i>{{ trans('button.export') }}
                    </button>
                    <button type="button" @click.prevent="applyFilters()" class="btn btn-outline-primary btn-sm rounded-pill me-2 text-capitalize-first">{{ trans('button.apply') }}</button>
                    <button type="button" @click.prevent="resetFilters()" class="btn btn-outline-secondary btn-sm rounded-pill text-capitalize-first">{{ trans('button.reset') }}</button>
                  </div>
                </div>

              </div>
            </div>
          </div>

          <div class="col-sm-12">
            <div class="card card-body">
              <div class="overflow-auto">

                <b-modal dialog-class="modal-xl"
                         title="Details"
                         :modelValue="details !== null"
                         body-class="pt-0"
                         @update:modelValue="$event === false && (details = null)"
                >
                  <template #default>
                    <InvoiceDetails :invoice="details"></InvoiceDetails>
                  </template>
                  <template #footer>
                    <button type="button" v-on:click="details = null" class="btn btn-outline-dark btn-sm text-capitalize-first">{{ trans("button.close") }}</button>
                  </template>
                </b-modal>


                <b-modal dialog-class=""
                         :title="trans('labels.invoice')"
                         :modelValue="invoiceCreateForm !== null"
                         body-class="pt-0"
                         @update:modelValue="$event === false && (invoiceCreateForm = null)"
                >
                  <template #default>
                    <div v-if="invoiceCreateForm">
                      <form>
                        <div class="row mb-2">
                          <div class="col-sm-12">

                            <div class="row mt-2">
                              <label for="type" class="col-sm-4 col-form-label text-capitalize-first">{{ trans("labels.type") }}</label>
                              <div class="col-sm-8">
                                <Multiselect id="type"
                                             class=""
                                             v-model="invoiceCreateForm.type"
                                             :options="[Direction.PAY_IN, Direction.PAY_OUT]"
                                             :custom-label="(opt) => trans(`direction.${opt}`)"
                                             :multiple="false"
                                             select-label="Select"
                                             placeholder=""
                                >
                                </Multiselect>
                              </div>
                            </div>

                            <div class="row mt-2">
                              <label for="amount" class="col-sm-4 col-form-label text-capitalize-first">{{ trans("labels.amount") }}</label>
                              <div class="col-sm-8">
                                <input v-model="invoiceCreateForm.amount" type="text" class="form-control " id="amount">
                              </div>
                            </div>

                            <div class="row mt-2">
                              <label for="currency" class="col-sm-4 col-form-label text-capitalize-first">{{ trans("labels.currency") }}</label>
                              <div class="col-sm-8">
                                <Multiselect id="currency"
                                             class=""
                                             v-model="invoiceCreateForm.currency"
                                             :options="store.getters['currencyMethods/currencies']"
                                             :custom-label="(opt) => `${opt}`"
                                             :multiple="false"
                                             select-label="Select"
                                             disabled
                                             placeholder=""
                                >
                                </Multiselect>
                              </div>
                            </div>

                            <div class="row mt-2">
                              <label for="store" class="col-sm-4 col-form-label text-capitalize-first">{{ trans("labels.store") }}</label>
                              <div class="col-sm-8">
                                <Multiselect id="store"
                                             class=""
                                             v-model="invoiceCreateForm.storeId"
                                             :options="store.getters['merchantStores/ids']"
                                             :custom-label="(opt) => store.getters['merchantStores/get'](opt)?.name"
                                             :multiple="false"
                                             select-label="Select"
                                             disabled
                                             placeholder=""
                                >
                                </Multiselect>
                              </div>
                            </div>

                            <div class="row mt-2" v-if="[Direction.PAY_IN, Direction.PAY_OUT].includes(invoiceCreateForm.type)">
                              <label for="paymentOption" class="col-sm-4 col-form-label text-capitalize-first">{{ trans("labels.payment_options") }}</label>
                              <div class="col-sm-8">
                                <Multiselect id="paymentOption"
                                             class=""
                                             v-model.number="invoiceCreateForm.paymentOption"
                                             @update:modelValue="invoiceCreateForm.paymentMethod = null"
                                             :options="store.getters['currencyMethods/options'](invoiceCreateForm.currency)"
                                             :custom-label="(opt) => trans(`payment_options.${opt}`)"
                                             :multiple="false"
                                             select-label="Select"
                                             placeholder=""
                                >
                                  <template #option="props">
                                    <div class="d-flex flex-row align-items-center gap-2">
                                      <span>{{ helper.trans('payment_options.' + props.option) }}</span>
                                    </div>
                                  </template>

                                  <template #singleLabel="props">
                                    <div class="d-flex flex-row align-items-center gap-1">
                                      <span>{{ helper.trans('payment_options.' + props.option) }}</span>
                                    </div>
                                  </template>

                                </Multiselect>
                              </div>
                            </div>

                            <div class="row mt-2" v-if="isCrossBorderCurrencyShown">
                              <label for="crossBorderCurrency" class="col-sm-4 col-form-label text-capitalize-first">{{ trans("labels.crossBorderCurrency") }}</label>
                              <div class="col-sm-8">
                                <Multiselect id="crossBorderCurrency"
                                             class=""
                                             v-model="invoiceCreateForm.crossBorderCurrency"
                                             :options="crossBorderCurrencies"
                                             :custom-label="(opt) => `${opt}`"
                                             :multiple="false"
                                             :allow-empty="false"
                                             select-label="Select"
                                             placeholder=""
                                >
                                </Multiselect>
                              </div>
                            </div>

                            <div class="row mt-2" v-if="[Direction.PAY_IN, Direction.PAY_OUT].includes(invoiceCreateForm.type)">
                              <label for="paymentMethod" class="col-sm-4 col-form-label text-capitalize-first">{{ trans("labels.payment_method") }}</label>
                              <div class="col-sm-8">
                                <Multiselect id="method"
                                             class=""
                                             v-model.number="invoiceCreateForm.paymentMethod"
                                             :options="store.getters['currencyMethods/methods'](invoiceCreateForm.currency, invoiceCreateForm.paymentOption)"
                                             :custom-label="(opt) => trans(`pay_methods.${opt}`)"
                                             :multiple="false"
                                             select-label="Select"
                                             placeholder=""
                                >
                                  <template #option="props">
                                    <div class="d-flex flex-row align-items-center gap-2">
                                      <PayMethodIcon icon-class="icon" :method="props.option"></PayMethodIcon>
                                      <span>{{ trans('pay_methods.' + props.option) }}</span>
                                    </div>
                                  </template>

                                  <template #singleLabel="props">
                                    <div class="d-flex flex-row align-items-center gap-1">
                                      <PayMethodIcon icon-class="icon" :method="props.option"></PayMethodIcon>
                                      <span>{{ trans('pay_methods.' + props.option) }}</span>
                                    </div>
                                  </template>

                                </Multiselect>
                              </div>
                            </div>

                            <div class="row mt-2" v-if="invoiceCreateForm.type === Direction.PAY_OUT">
                              <label for="requisites" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.requisites") }}</label>
                              <div class="col-sm-8">
                                <input v-model="invoiceCreateForm.requisites"
                                       v-maska
                                       :data-maska="requisitesMaskaOptions.pattern"
                                       :data-maska-tokens="requisitesMaskaOptions.tokens"
                                       type="text" class="form-control " id="requisites">
                              </div>
                            </div>

                            <div class="row mt-2" v-if="invoiceCreateForm.type === Direction.PAY_OUT">
                              <label for="holderName" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.holder_name") }}</label>
                              <div class="col-sm-8">
                                <input v-model="invoiceCreateForm.holder" type="text" class="form-control " id="holderName">
                              </div>
                            </div>

                            <div class="row mt-2" v-if="invoiceCreateForm.type === Direction.PAY_IN">
                              <label for="startDeal" class="col-sm-4 col-form-label text-capitalize-first">{{ trans("labels.create_deal") }}</label>
                              <div class="col-sm-8 d-flex align-items-center">
                                <input v-model="invoiceCreateForm.startDeal" id="startDeal" class="form-check-input" type="checkbox">
                              </div>
                            </div>

                            <div class="row mt-2">
                              <label for="internalId" class="col-sm-4 col-form-label text-capitalize-first">{{ trans("labels.invoice_id") }}</label>
                              <div class="col-sm-8">
                                <input v-model="invoiceCreateForm.internalId" type="text" class="form-control " id="internalId">
                              </div>
                            </div>

                            <div class="row mt-2">
                              <label for="userId" class="col-sm-4 col-form-label text-capitalize-first">{{ trans("labels.uid") }}</label>
                              <div class="col-sm-8">
                                <input v-model="invoiceCreateForm.userId" type="text" class="form-control " id="userId">
                              </div>
                            </div>

                          </div>
                        </div>
                      </form>

                    </div>
                  </template>
                  <template #footer>
                    <button type="button" v-on:click="invoiceCreateForm = null" class="btn btn-outline-dark btn-sm text-capitalize-first">{{ trans("button.cancel") }}</button>
                    <button type="button" v-on:click="createInvoice" class="btn btn-outline-primary btn-sm text-capitalize-first">{{ trans("button.create") }}</button>
                  </template>
                </b-modal>

                <table class="table table-striped border-light align-middle text-left text-nowrap position-relative">
                  <thead>
                  <tr>
                    <th class="text-capitalize-first">{{ trans("labels.id") }}</th>
                    <th class="text-capitalize-first">{{ trans("labels.type") }}</th>
                    <th class="text-capitalize-first">{{ trans("labels.payment_option") }}</th>
                    <th class="text-capitalize-first">{{ trans("labels.payment_method") }}</th>
                    <th class="text-capitalize-first">{{ trans("labels.date") }}</th>
                    <th class="text-capitalize-first">{{ trans("labels.store") }}</th>
                    <th class="text-capitalize-first">{{ trans("labels.uid") }}</th>
                    <th class="text-capitalize-first">{{ trans("labels.sum") }}</th>
                    <th class="text-capitalize-first">{{ trans("labels.status") }}</th>
                    <th class="text-capitalize-first" v-if="isAdmin || isOperator">{{ trans("labels.time_spent_deal") }}</th>
                    <th class="text-capitalize-first">{{ trans("labels.payout_sum") }}</th>
                    <th class="text-end"><button v-if="currentStore?.isActive && store.getters.isMerchant" type="button" @click="showCreateInvoiceForm" class="btn btn-sm btn-outline-primary text-capitalize-first">{{ trans("button.create_invoice")}}</button></th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="invoice in invoices.items" :key="invoice.id">
                    <td>
                      <div class="d-flex flex-column mt-1 mb-1">
                        <span>
                          <span :title="invoice.id">{{ invoice.id.substring(0, 8) }}...</span> <copy-button :value="invoice.id"></copy-button>
                        </span>
                        <small class="text-secondary">{{ invoice.internalId ?? 'n/a' }}</small>
                      </div>
                    </td>
                    <td>{{ helper.trans(`direction.${invoice.type}`) }}</td>
                    <td>{{ invoice.paymentOption ? helper.trans(`payment_options.${invoice.paymentOption}`) : 'n/a' }}</td>
                    <td>{{ invoice.paymentMethod ? helper.trans(`pay_methods.${invoice.paymentMethod}`) : 'n/a' }}</td>
                    <td>{{ dateHelper.format(invoice.createdAt) }}</td>
                    <td>{{ invoice.storeName }}</td>
                    <td>{{ invoice.userId ?? 'n/a' }}</td>
                    <td>{{ numberFormatter.formatMoney(invoice.sum)}}</td>
                    <td>
                      <div class="d-flex flex-column mt-1 mb-1">
                        <span>
                          {{ trans(`invoice_status.${invoice.status}`) }}
                        </span>
                        <small class="text-secondary">{{ dateHelper.format(invoice.updatedAt) }}</small>
                      </div>
                    </td>
                    <td v-if="isAdmin || isOperator">{{ invoice.timeSpentCreateDeal }}</td>
                    <td>{{ invoice.payoutSum ? numberFormatter.formatMoney(invoice.payoutSum) : 'n/a'}}</td>
                    <td class="text-end">
                      <button type="button" @click="details = invoice" class="btn btn-sm btn-outline-dark text-nowrap text-capitalize"><i class="fa fa-list"></i>
                        {{ trans("button.details") }}</button>
                    </td>
                  </tr>
                  </tbody>
                </table>

                <b-pagination
                  v-if="invoices.totalCount > invoices.items.length"
                  v-model="page"
                  :total-rows="invoices.totalCount"
                  :per-page="invoices.limit"
                  :limit="20"
                  @update:modelValue="load()"
                  prev-text="Back"
                  next-text="Next"
                  align="start"
                  first-number
                  hide-goto-end-buttons
                  hide-ellipsis
                ></b-pagination>
              </div>

            </div>
          </div>

        </div>
      </div>
    </div>
  </LoaderWrapper>
</template>
<script lang="ts">
import LoaderWrapper from "@/components/LoaderWrapper.vue";
import {defineComponent, onMounted, toRefs, reactive, ref, ComputedRef, computed, watch} from 'vue'
import {dateHelper} from "@/service/DateHelper";
import {numberFormatter} from "@/service/NumberFormatter";
import APIClient from "@/service/APIClient";
import PaginatedResponseDTO from "@/models/PaginatedResponseDTO";
import {helper, trans} from "@/service/CommonHelper";
import {BModal, BPagination} from "bootstrap-vue-3";
import InvoiceDTO from "@/models/InvoiceDTO";
import CopyButton from "@/components/CopyButton.vue";
import InvoiceDetails from "@/components/InvoiceDetails.vue";
import {InvoiceStatus} from "@/models/enum/InvoiceStatus";
import Multiselect from "vue-multiselect";
import {DatePicker} from "v-calendar";
import InvoicesRequestDTO from "@/models/request/InvoicesRequestDTO";
import {useStore} from "vuex";
import MerchantStoreDTO from "@/models/MerchantStoreDTO";
import {Direction} from "@/models/enum/Direction";
import {PaymentOption} from "@/models/enum/PaymentOption";
import moment from "moment/moment";
import PayMethodIcon from "@/components/PayMethodIcon.vue";
import ConfirmModal from "@/components/ConfirmModal.vue";
import {createExportTask} from "@/service/exportTaskCreate";
import {notify} from "@kyvg/vue3-notification";

const api = new APIClient();

const defaultInvoiceForm = {
  type: Direction.PAY_IN,
  amount: null,
  currency: null,
  storeId: null,
  internalId: null,
  userId: null,
  paymentOption: null,
  paymentMethod: null,
  crossBorderCurrency: null,
  requisites: null,
  startDeal: true
}

const CROSS_BORDER_CURRENCY_OPTIONS: string[] = [
  PaymentOption.CROSS_BORDER,
  PaymentOption.MOBILE_TOP_UP,
  PaymentOption.SBP_QR,
  PaymentOption.CARD_ACQUIRING_REDIRECT,
];

const DEFAULT_CROSS_BORDER_CURRENCY = 'RUB';

const defaultRequestDTO = {
  id: null,
  userId: null,
  statuses: [],
  storeIds: [],
  fromDate: moment().subtract(7, 'day').format('YYYY-MM-DD 00:00:00'),
  toDate: null,
  fromSum: null,
  toSum: null,
  currencies: [],
} as InvoicesRequestDTO;

export default defineComponent({
  components: {
    ConfirmModal,
    PayMethodIcon,
    LoaderWrapper,
    BPagination,
    BModal,
    CopyButton,
    InvoiceDetails,
    Multiselect,
    DatePicker
  },
  setup() {
    const store = useStore();
    const pageLoader = ref<InstanceType<typeof LoaderWrapper> | null>(null)
    const confirmModal = ref<InstanceType<typeof ConfirmModal> | null>(null);
    const currentStore = computed<MerchantStoreDTO|null>(() => store.getters["merchantStores/getCurrent"]);

    const state = reactive({
      requestDTO: {...defaultRequestDTO} as InvoicesRequestDTO,
      details: null as InvoiceDTO|null,
      invoiceCreateForm: null as any|null,
      page: 1,
      invoices: {
          limit: 20,
          offset: 0,
          totalCount: 0,
          items: []
      } as PaginatedResponseDTO<InvoiceDTO>
    });

    const prepareFilters = () => ({
      ...state.requestDTO,
      storeIds: currentStore.value === null ? state.requestDTO.storeIds : [currentStore.value.id],
      currencies: currentStore.value?.isActive && store.getters.isMerchant
        ? [currentStore.value.currency]
        : state.requestDTO.currencies,
      fromDate: dateHelper.toUTC(state.requestDTO.fromDate),
      toDate: dateHelper.toUTC(state.requestDTO.toDate),
    });

    const exportInvoices = async () => {
      try {
        await createExportTask(store, confirmModal, 'invoices', prepareFilters());
        notify({type: 'success', text: trans('export_tasks.export_started')});
      } catch (e) {
        notify({type: 'error', text: trans('export_tasks.generation_error')});
      }
    };

    const showCreateInvoiceForm = () => {
      state.invoiceCreateForm = {
        ...defaultInvoiceForm,
        type: Direction.PAY_IN,
        currency: currentStore.value?.currency,
        storeId: currentStore.value?.id
      }
    }

    const crossBorderCurrencies = computed<string[]>(() => store.getters['currencyMethods/crossBorderCurrencies'] ?? []);

    const isCrossBorderCurrencyShown = computed(() =>
      state.invoiceCreateForm?.type === Direction.PAY_IN
      && CROSS_BORDER_CURRENCY_OPTIONS.includes(state.invoiceCreateForm.paymentOption)
    );

    const syncCrossBorderCurrency = () => {
      if (state.invoiceCreateForm === null) {
        return;
      }

      if (!isCrossBorderCurrencyShown.value) {
        state.invoiceCreateForm.crossBorderCurrency = null;
        return;
      }

      if (!crossBorderCurrencies.value.includes(state.invoiceCreateForm.crossBorderCurrency)) {
        state.invoiceCreateForm.crossBorderCurrency = crossBorderCurrencies.value.includes(DEFAULT_CROSS_BORDER_CURRENCY)
          ? DEFAULT_CROSS_BORDER_CURRENCY
          : (crossBorderCurrencies.value[0] ?? null);
      }
    }

    watch(
      () => [state.invoiceCreateForm?.type, state.invoiceCreateForm?.paymentOption, crossBorderCurrencies.value],
      syncCrossBorderCurrency
    );

    const createInvoice = async () => {
      pageLoader.value?.show()
      const invoice = await api.createInvoice(state.invoiceCreateForm!)
      state.invoiceCreateForm = null
      await load()
      state.details = invoice
    }

    const load = async () => {
      state.invoices.offset = state.invoices.limit * (state.page - 1)
      pageLoader.value?.show()
      state.invoices = await api.invoices(state.invoices, {createdAt: 'desc'}, prepareFilters())
      pageLoader.value?.hide()
    }

    const applyFilters = async () => {
      state.page = 1;
      load()
    }

    const resetFilters = async () => {
      state.page = 1;
      state.requestDTO = {...defaultRequestDTO};
      load()
    }

    const requisitesMaskaOptions = computed(() => {
      if (!state.invoiceCreateForm.paymentMethod || !state.invoiceCreateForm.requisites) {
        return {
          pattern: null,
          tokens: null
        }
      }


      if (state.invoiceCreateForm.requisites && state.invoiceCreateForm.requisites.startsWith('+')) {
        return {pattern: helper.getPhonePattern(state.invoiceCreateForm.requisites), tokens: '9:[0-9]:repeated'};
      }

      return {
        pattern: '#### #### #### ####',
        tokens: '9:[0-9]:repeated'
      }
    })

    onMounted(() => {
      load();
    });

    return {
      ...toRefs(state),
      pageLoader,
      confirmModal,
      exportInvoices,
      dateHelper,
      numberFormatter,
      load,
      InvoiceStatus,
      resetFilters,
      applyFilters,
      trans,
      currencyList: computed(() => store.getters["currencyMethods/currencies"]),
      storeIds: computed(() => store.getters["merchantStores/ids"]),
      store,
      defaultInvoiceForm,
      createInvoice,
      showCreateInvoiceForm,
      currentStore,
      Direction,
      helper,
      requisitesMaskaOptions,
      crossBorderCurrencies,
      isCrossBorderCurrencyShown,
      isAdmin: computed(() => store.getters.isAdmin),
      isOperator: computed(() => store.getters.isOperator),
    }
  },
  async beforeMount() {
    const store = useStore();
    await store.dispatch("currencyMethods/loadList");
    if (!store.getters.isAdmin) {
      await store.dispatch('merchantStores/loadList')
    }
  }
})
</script>
